module.exports = __webpack_public_path__ + "static/media/cjhy.fea24d92.jpeg";